export default {
  frontRoutes: [
    {
      path: "/vip",
      name: "Vip",
      component: () =>
        import(/* webpackChunkName: "oto" */ "../views/vip/Vip.vue"),
    },
  ],
};
